import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
export class zfcf {
    static getDisplayDateTime() {
        var displayDate = $('meta[name="zf:display_date"]').attr("content"), dateTimeMatch = displayDate
            ? displayDate.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})([+-]\d{2})(\d{2})$/)
            : null;
        return dateTimeMatch
            ? dateTimeMatch[1] + dateTimeMatch[2] + ":" + dateTimeMatch[3]
            : displayDate || "";
    }
    static getDisplayDate() {
        var _a;
        var displayDate = $('meta[name="zf:display_date"]').attr("content"), dateMatch = displayDate ? displayDate.match(/^(\d{4})-(\d{2})-(\d{2})/) : null, lang = (((_a = document.querySelector("html")) === null || _a === void 0 ? void 0 : _a.lang) || $('meta[name="lang"]').attr("content") || "en").replace("_", "-");
        if (!dateMatch)
            return "";
        var dateSample = new Intl.DateTimeFormat(lang, {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        }).format(new Date(2001, 10, 22)), monthFirst = dateSample.indexOf("11") < dateSample.indexOf("22"), month = dateMatch[2], day = dateMatch[3], year = dateMatch[1];
        return monthFirst ? month + "/" + day + "/" + year : day + "/" + month + "/" + year;
    }
    static toggleSlide() {
        var that = $(this), isOpen = that.parent().hasClass("zfcf-content-open"), openItems = $(".zfcf-content-open");
        if (!isOpen) {
            if (openItems.length) {
                openItems.find(".zfcf-item-content").slideUp(300, function () {
                    that.parent().addClass("zfcf-content-open");
                    that.parent().find(".zfcf-item-content").slideDown(300);
                });
            }
            else {
                that.parent().addClass("zfcf-content-open");
                that.parent().find(".zfcf-item-content").slideDown(300);
            }
        }
        else {
            openItems.find(".zfcf-item-content").slideUp(300);
        }
        openItems.removeClass("zfcf-content-open");
    }
    static init(footerData) {
        try {
            var includeSeparator = "";
            footerData.items.forEach(function (item) {
                if (item.headline.length == 0 &&
                    item.text.length == 0 &&
                    includeSeparator != "true") {
                    includeSeparator = "false";
                }
                else {
                    includeSeparator = "true";
                }
            });
            footerData["includeSeparator"] = includeSeparator;
            footerData["displayDate"] = zfcf.getDisplayDate();
            footerData["displayDateTime"] = zfcf.getDisplayDateTime();
            var footerTemplate = zfUtils.handlebarsCompile(`
				<!-- NOINDEX BEGIN -->
				<footer class="zfcf-footer {{class}}">
					<div class="zfcf-footer-content zfc-wrapper-content">
					  <div class="zfcf-footer-top">
						<div class="zfcf-footer-top-content">
						  <div class="row">
							<div class="zfcf-display-date">
								<span class="zfcui-prometo-light">{{#trans 'last_updated'}}{{/trans}}: <time datetime="{{displayDateTime}}">{{displayDate}}</time></span>
							</div>
						  	{{#ifCond social.length '>' '0'}}
							<div class="zfcf-social-block">
								<div class="zfcf-social-label zfcui-prometo-light">
          							<span>{{#trans 'follow_zf'}}{{/trans}}</span>
        						</div>
        						<div class="zfcf-social-icons">
        						  {{#each social}}
        						    <a href="{{href}}" title="{{#trans 'follow_zf_on'}}{{/trans}} {{label}}" class="zfcf-icon-link" target="_blank" aria-label="{{label}}(opens in a new tab)">
        						      <span class="zfcui-icon zfcui-icon-{{type}}" role="button" aria-hidden="true"></span>
        						    </a>      		
        						  {{/each}}
        						</div>
							</div>
							{{/ifCond}}
						  </div>
						  ` +
                zfc.dividerHtml +
                `
						</div>
					</div>
				{{#if items.length}}
				  <div class="zfcf-footer-middle zfcf-col-{{colsCount}}">
					<div class="zfcf-footer-middle-content{{#ifCond includeSeparator '==' 'false'}} zfcf-footer-middle-content-empty{{/ifCond}}">
					  <div class="row">
					  {{#each items}}
						{{#ifCond @index '%' '2'}}
							<div class="zfcf-footer-bottom-column">
						{{/ifCond}}
						<div class="zfcf-mid-item zfcui-prometo-medium{{#ifCond headline.length '==' 0}} zfcf-item-empty{{/ifCond}}">
							<span class="zfcf-item-title">
							  <span class="zfcf-item-title-label">{{headline}}</span>
							</span>
						  <div class="zfcf-item-content">{{#decodeHtml text}}{{/decodeHtml}}</div>
						</div>
						{{#ifCond @index '!%' '2'}}
							</div>
						{{/ifCond}}
					  {{/each}}
					  </div>
					  {{#ifCond includeSeparator '==' 'true'}}
					  	` +
                zfc.dividerHtml +
                `
					  {{/ifCond}}
					</div>
				  </div>
				{{/if}}
				  <div class="zfcf-footer-bottom">
					<div class="zfcf-footer-bottom-content">
					  <div class="zfcf-footer-menu">
					   {{#each links}}
						  <a class="zfcf-footer-menu-item zfcui-prometo-medium" {{#ifCond href 'includes' 'javascript:'}} onClick="{{href}}" {{/ifCond}} {{#ifCond href '!includes' 'javascript:'}} href="{{href}}" {{/ifCond}} target="{{target}}">{{text}}</a>	
					   {{/each}}
					  </div>
					  <div class="zfcf-footer-copyright zfcui-prometo-light">
						<span class="zfcf-footer-copyright-text"><b>{{copyright}}</b></span>
					  </div>
					</div>
				  </div>    
				</div>
				</footer>
				<!-- NOINDEX END -->`);
            $(".body-wrapper").append(zfUtils.handlebarsProcessTemplate(footerTemplate, footerData));
            $(".zfcf-item-title").each(function () {
                var that = $(this);
                var regions = "";
                var allRegions = false;
                that
                    .closest(".zfcf-mid-item")
                    .find("a")
                    .each(function () {
                    if ($(this).attr("data-region") == undefined)
                        allRegions = true;
                    else
                        regions = regions + "," + $(this).data("region");
                });
                if (!allRegions)
                    that.attr("data-region", regions);
            });
        }
        catch (err) {
            console.log("Initalization failed: zfcf.init()\t" +
                (err instanceof Error ? err.message : String(err)));
        }
    }
}
